import { createIcon } from '@chakra-ui/icons';

export const DirectAssignmentInstance = createIcon({
  displayName: 'DirectAssignmentInstance',
  viewBox: '0 0 9 10',
  path: [
    <svg xmlns="http://www.w3.org/2000/svg" width="9" height="10" viewBox="0 0 9 10" fill="none">
      <g id="clone-dashed 1">
        <g id="Group">
          <path
            id="Vector"
            d="M3.75 8.75H3.1875C2.67075 8.75 2.25 8.32925 2.25 7.8125V6.5H3V7.8125C3 7.916 3.084 8 3.1875 8H3.75V8.75Z"
            fill="currentColor"
          />
          <path id="Vector_2" d="M6 8H4.5V8.75H6V8Z" fill="currentColor" />
          <path
            id="Vector_3"
            d="M7.3125 8.75H6.75V8H7.3125C7.416 8 7.5 7.916 7.5 7.8125V7.25H8.25V7.8125C8.25 8.32925 7.82925 8.75 7.3125 8.75Z"
            fill="currentColor"
          />
          <path id="Vector_4" d="M8.25 5H7.5V6.5H8.25V5Z" fill="currentColor" />
          <path
            id="Vector_5"
            d="M8.25 4.25H7.5V3.6875C7.5 3.584 7.416 3.5 7.3125 3.5H6V2.75H7.3125C7.82925 2.75 8.25 3.17075 8.25 3.6875V4.25Z"
            fill="currentColor"
          />
          <path
            id="Vector_6"
            d="M1.6875 1.75H5.8125C6.05412 1.75 6.25 1.94588 6.25 2.1875V6.3125C6.25 6.55412 6.05412 6.75 5.8125 6.75H1.6875C1.44588 6.75 1.25 6.55412 1.25 6.3125V2.1875C1.25 1.94588 1.44588 1.75 1.6875 1.75Z"
            stroke="currentColor"
          />
        </g>
      </g>
    </svg>,
  ],
});
